import { render, staticRenderFns } from "./bidTemplatePreview.vue?vue&type=template&id=a4b4bc82"
import script from "./bidTemplatePreview.vue?vue&type=script&lang=js"
export * from "./bidTemplatePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports